import { render, staticRenderFns } from "./VersionsLayoutsModal.vue?vue&type=template&id=0dad42a2&scoped=true"
import script from "./VersionsLayoutsModal.vue?vue&type=script&lang=js"
export * from "./VersionsLayoutsModal.vue?vue&type=script&lang=js"
import style0 from "./VersionsLayoutsModal.vue?vue&type=style&index=0&id=0dad42a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dad42a2",
  null
  
)

export default component.exports